import { LOGOUT_URL } from '../../common/common-constants'
import { apiBaseUrl } from '../../common/services/api-service'
import {
  clearStorage,
  getSessionToken
} from '../../common/services/local-storage-service'

export function logoutAndRedirect(): void {
  const token = getSessionToken()
  clearStorage(false)
  window.location.href = apiBaseUrl() + LOGOUT_URL + token
}

export const userLogout = () => {
  clearStorage()
}
